<template>
  <v-layout
    wrap
    align-content-center
  >
    <v-flex
      xs12
      md6
      class="form-left-column"
    >
      <v-text-field
        v-model="form.values.name"
        :error-messages="getRequiredErrors(form.errors.name)"
        :label="$t('profile.form.name')"
      />
      <v-text-field
        v-model="form.values.surname"
        :error-messages="getRequiredErrors(form.errors.surname)"
        :label="$t('profile.form.surname')"
      />
      <v-text-field
        v-model="form.values.phone"
        :error-messages="getPhoneErrors(form.errors.phone)"
        :label="$t('profile.form.phone')"
      />
    </v-flex>
    <v-spacer />
    <v-flex
      xs12
      md6
      class="form-right-column"
    >
      <v-text-field
        v-model="form.values.street"
        :error-messages="getRequiredErrors(form.errors.street)"
        :label="$t('profile.form.street')"
      />
      <v-text-field
        v-model="form.values.city"
        :error-messages="getRequiredErrors(form.errors.city)"
        :label="$t('profile.form.city')"
      />
      <v-text-field
        v-model="form.values.zipCode"
        :error-messages="getRequiredErrors(form.errors.zipCode)"
        :label="$t('profile.form.zipCode')"
      />
      <v-autocomplete
        v-model="form.values.country"
        :error-messages="getRequiredErrors(form.errors.country)"
        :items="countries"
        :no-data-text="$t('messages.noDataAvailable')"
        item-text="name"
        item-value="id"
        :label="$t('profile.form.country')"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { countries } from '../../config'

export default {
  name: 'ProfileFormFields',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      countries,
    }
  },
  methods: {
    getRequiredErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      return errors
    },
    getPhoneErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      if (values.phone) errors.push(this.$t('validates.phoneNumber'))
      return errors
    },
  },
}
</script>

<style scoped>
@media only screen and (min-width: 960px)  {
  .form-left-column {
    padding-right: 20px !important;
  }
  .form-right-column {
    padding-left: 20px !important;
  }
}
</style>
